exports.list = {
    path: '/complaint',
    name: 'complaint_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/complaint/List.vue"),
}
exports.show = {
    path: '/complaint/show/:id',
    name: 'complaint_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/complaint/Show.vue"),
}